export type VisitStatus = "Pending" | "Confirmed" | "Rejected" | "Completed";

export interface JobCardVisit {
  id: number;
  jobNo: string;
  projectTitle: string;
  clientName: string;
  clientPhone: string;
  clientEmail: string;
  clientCompany: string;
  surveyLocation: string;
  services: string[];
  assignedDate: string;
  completionDate: string;
  priority: string;
  status: string;
  fieldVisitRequired: boolean;
}

export interface SiteVisitRequest {
  id: number;
  refNo: string;
  clientName: string;
  clientEmail: string;
  clientPhone: string;
  company: string;
  jobRef: string;
  serviceType: string;
  preferredDate: string;
  alternateDate: string;
  timeSlot: string;
  attendees: number;
  siteAddress: string;
  purpose: string;
  specialRequirements: string;
  status: VisitStatus;
  submittedAt: string;
  confirmedBy?: string;
  confirmedAt?: string;
  rejectionReason?: string;
  notes?: string;
}

export const mockSiteVisitRequests: SiteVisitRequest[] = [
  {
    id: 1,
    refNo: "SVR-2026-001",
    clientName: "Rajesh Sharma",
    clientEmail: "rajesh.sharma@infratech.in",
    clientPhone: "+91 98765 43210",
    company: "InfraTech Developers Pvt Ltd",
    jobRef: "HYD-SURV-2026-04-0034",
    serviceType: "Topographic Survey",
    preferredDate: "2026-04-10",
    alternateDate: "2026-04-12",
    timeSlot: "10:00 AM – 12:00 PM",
    attendees: 3,
    siteAddress: "Plot No. 45, Shamshabad Industrial Zone, Hyderabad, TS 501218",
    purpose: "Initial site inspection and survey scope discussion with the field team",
    specialRequirements: "Please bring the preliminary survey report. We will have our architect present.",
    status: "Pending",
    submittedAt: "2026-04-07T09:15:00",
  },
  {
    id: 2,
    refNo: "SVR-2026-002",
    clientName: "Priya Nair",
    clientEmail: "priya.nair@greenvalley.com",
    clientPhone: "+91 87654 32109",
    company: "Green Valley Constructions",
    jobRef: "HYD-SURV-2026-04-0033",
    serviceType: "DGPS Survey",
    preferredDate: "2026-04-09",
    alternateDate: "2026-04-11",
    timeSlot: "2:00 PM – 4:00 PM",
    attendees: 2,
    siteAddress: "ORR Km 42-48, Patancheru, Hyderabad, TS 502319",
    purpose: "Review of DGPS control points and alignment verification",
    specialRequirements: "Access to site requires prior security clearance. Will arrange.",
    status: "Confirmed",
    submittedAt: "2026-04-06T14:30:00",
    confirmedBy: "Suresh (Admin)",
    confirmedAt: "2026-04-06T16:00:00",
    notes: "Confirmed for April 9. Team lead Kiran Babu will be present.",
  },
  {
    id: 3,
    refNo: "SVR-2026-003",
    clientName: "Anil Reddy",
    clientEmail: "anil.reddy@kompallyhomes.in",
    clientPhone: "+91 76543 21098",
    company: "Kompally Homes & Estates",
    jobRef: "HYD-SURV-2026-04-0029",
    serviceType: "Boundary Survey",
    preferredDate: "2026-04-08",
    alternateDate: "2026-04-09",
    timeSlot: "8:00 AM – 10:00 AM",
    attendees: 4,
    siteAddress: "Survey No. 112/A, Kompally, Hyderabad, TS 500014",
    purpose: "Dispute resolution meeting — north boundary clarification with adjacent landowner",
    specialRequirements: "Legal representative will be present. Please bring all boundary documentation.",
    status: "Pending",
    submittedAt: "2026-04-07T07:45:00",
  },
  {
    id: 4,
    refNo: "SVR-2026-004",
    clientName: "Meena Krishnan",
    clientEmail: "meena.k@vijayawadainfra.com",
    clientPhone: "+91 65432 10987",
    company: "Vijayawada Infrastructure Ltd",
    jobRef: "HYD-SURV-2026-04-0030",
    serviceType: "Hydrogeological Survey",
    preferredDate: "2026-04-05",
    alternateDate: "2026-04-06",
    timeSlot: "12:00 PM – 2:00 PM",
    attendees: 2,
    siteAddress: "NH-65, Km 8-14, Vijayawada, AP 520001",
    purpose: "Mid-survey progress review and borehole data discussion",
    specialRequirements: "None",
    status: "Completed",
    submittedAt: "2026-04-03T11:00:00",
    confirmedBy: "Ravi (Admin)",
    confirmedAt: "2026-04-03T13:00:00",
    notes: "Visit completed successfully. Client satisfied with progress.",
  },
  {
    id: 5,
    refNo: "SVR-2026-005",
    clientName: "Sudhir Patel",
    clientEmail: "sudhir.patel@patelbuildcon.com",
    clientPhone: "+91 54321 09876",
    company: "Patel Build & Con",
    jobRef: "HYD-SURV-2026-03-0021",
    serviceType: "Contour Mapping",
    preferredDate: "2026-04-15",
    alternateDate: "2026-04-17",
    timeSlot: "10:00 AM – 12:00 PM",
    attendees: 1,
    siteAddress: "Gachibowli IT Corridor, Hyderabad, TS 500032",
    purpose: "Pre-construction contour review for foundation planning",
    specialRequirements: "Prefer morning slot. Site access available from 8 AM.",
    status: "Rejected",
    submittedAt: "2026-04-05T10:00:00",
    rejectionReason: "Requested dates conflict with ongoing survey at the same site. Client asked to reschedule after April 20.",
  },
  {
    id: 6,
    refNo: "SVR-2026-006",
    clientName: "Lakshmi Devi",
    clientEmail: "lakshmi.devi@srisaibuilders.in",
    clientPhone: "+91 43210 98765",
    company: "Sri Sai Builders",
    jobRef: "HYD-SURV-2026-04-0035",
    serviceType: "Layout Planning",
    preferredDate: "2026-04-11",
    alternateDate: "2026-04-14",
    timeSlot: "4:00 PM – 6:00 PM",
    attendees: 5,
    siteAddress: "Bachupally, Hyderabad, TS 500090",
    purpose: "Layout approval walkthrough with municipal engineer and client team",
    specialRequirements: "Need projector/screen setup for presentation. Will bring laptop.",
    status: "Pending",
    submittedAt: "2026-04-07T11:30:00",
  },
];
